import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID, inject } from '@angular/core';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { UserDataService } from '../../shared/services/userData.service';

@Component({
  selector: 'app-building-shell',
  standalone: true,
  imports: [CommonModule, RouterOutlet],
  template: `<router-outlet />`
})
export class BuildingShellComponent {
  private readonly route = inject(ActivatedRoute);
  private readonly userDataService = inject(UserDataService);

  constructor(@Inject(PLATFORM_ID) platformId: object) {
    this.route.paramMap.subscribe((params) => {
      const buildingId = params.get('buildingId');
      if (!buildingId) {
        return;
      }

      this.userDataService.setBuildingId(buildingId);

      if (isPlatformBrowser(platformId)) {
        localStorage.setItem('forms_building_id', buildingId);
      }
    });

    if (isPlatformBrowser(platformId)) {
      const persistedBuildingId = localStorage.getItem('forms_building_id');
      if (persistedBuildingId) {
        this.userDataService.setBuildingId(persistedBuildingId);
      }
    }
  }
}
